// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itanotificationpg-inline-1 {
  margin-bottom: 16px;
}

.itanotificationpg-inline-2 {
  flex-wrap: wrap;
  gap: 12px;
}

.itanotificationpg-inline-3 {
  display: flex;
  gap: 8px;
  align-items: center;
}

.itanotificationpg-inline-4 {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  cursor: pointer;
}

.itanotificationpg-inline-5 {
  display: flex;
  gap: 6px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.itanotificationpg-inline-6 {
  padding: 0;
}

.itanotificationpg-inline-7 {
  text-align: center;
  padding: 40px;
  color: #94a3b8;
  font-size: 13px;
}

.itanotificationpg-inline-8 {
  text-align: center;
  padding: 40px;
}

.itanotificationpg-inline-9 {
  font-size: 36px;
  margin-bottom: 8px;
}

.itanotificationpg-inline-10 {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
}

.itanotificationpg-inline-11 {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 4px;
}

.itanotificationpg-inline-12 {
  flex: 1 1;
  min-width: 0;
}

.itanotificationpg-inline-13 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
}

.itanotificationpg-inline-14 {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #6366f1;
  flex-shrink: 0;
}

.itanotificationpg-inline-15 {
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.itanotificationpg-inline-16 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
}

.itanotificationpg-inline-17 {
  font-size: 11px;
  color: #94a3b8;
}

.itanotificationpg-inline-18 {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #cbd5e1;
  font-size: 14px;
  flex-shrink: 0;
  margin-top: 2px;
}

.itanotificationpg-inline-19 {
  margin-top: 12px;
}

.itanotificationpg-inline-20 {
  font-size: 14px;
  font-weight: 700;
}

.itanotificationpg-inline-21 {
  font-size: 13px;
  color: #475569;
  margin-top: 8px;
}

.itanotificationpg-dyn-1 {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border: var(--itanotificationpg-1-border);
  background: var(--itanotificationpg-1-background);
  color: var(--itanotificationpg-1-color);
}

.itanotificationpg-dyn-2 {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 20px;
  background: var(--itanotificationpg-2-background);
  border-bottom: 1px solid #f1f5f9;
  cursor: var(--itanotificationpg-2-cursor);
  transition: background 0.15s;
}

.itanotificationpg-dyn-3 {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--itanotificationpg-3-background);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.itanotificationpg-dyn-4 {
  font-size: 13px;
  font-weight: var(--itanotificationpg-4-font-weight);
  color: var(--itanotificationpg-4-color);
}

.itanotificationpg-dyn-5 {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  background: var(--itanotificationpg-5-background);
  color: var(--itanotificationpg-5-color);
  text-transform: capitalize;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/ITAdmin/ITANotificationpg.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,iDAAiD;EACjD,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,iDAAiD;EACjD,gCAAgC;EAChC,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mDAAmD;EACnD,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;EACjD,uCAAuC;EACvC,0BAA0B;AAC5B","sourcesContent":[".itanotificationpg-inline-1 {\n  margin-bottom: 16px;\n}\n\n.itanotificationpg-inline-2 {\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.itanotificationpg-inline-3 {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.itanotificationpg-inline-4 {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 8px;\n  padding: 6px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #2563eb;\n  cursor: pointer;\n}\n\n.itanotificationpg-inline-5 {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.itanotificationpg-inline-6 {\n  padding: 0;\n}\n\n.itanotificationpg-inline-7 {\n  text-align: center;\n  padding: 40px;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n.itanotificationpg-inline-8 {\n  text-align: center;\n  padding: 40px;\n}\n\n.itanotificationpg-inline-9 {\n  font-size: 36px;\n  margin-bottom: 8px;\n}\n\n.itanotificationpg-inline-10 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.itanotificationpg-inline-11 {\n  font-size: 12px;\n  color: #94a3b8;\n  margin-top: 4px;\n}\n\n.itanotificationpg-inline-12 {\n  flex: 1;\n  min-width: 0;\n}\n\n.itanotificationpg-inline-13 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 2px;\n}\n\n.itanotificationpg-inline-14 {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #6366f1;\n  flex-shrink: 0;\n}\n\n.itanotificationpg-inline-15 {\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n.itanotificationpg-inline-16 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 6px;\n}\n\n.itanotificationpg-inline-17 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.itanotificationpg-inline-18 {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  color: #cbd5e1;\n  font-size: 14px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.itanotificationpg-inline-19 {\n  margin-top: 12px;\n}\n\n.itanotificationpg-inline-20 {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.itanotificationpg-inline-21 {\n  font-size: 13px;\n  color: #475569;\n  margin-top: 8px;\n}\n\n.itanotificationpg-dyn-1 {\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  border: var(--itanotificationpg-1-border);\n  background: var(--itanotificationpg-1-background);\n  color: var(--itanotificationpg-1-color);\n}\n\n.itanotificationpg-dyn-2 {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 14px 20px;\n  background: var(--itanotificationpg-2-background);\n  border-bottom: 1px solid #f1f5f9;\n  cursor: var(--itanotificationpg-2-cursor);\n  transition: background 0.15s;\n}\n\n.itanotificationpg-dyn-3 {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: var(--itanotificationpg-3-background);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.itanotificationpg-dyn-4 {\n  font-size: 13px;\n  font-weight: var(--itanotificationpg-4-font-weight);\n  color: var(--itanotificationpg-4-color);\n}\n\n.itanotificationpg-dyn-5 {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: var(--itanotificationpg-5-background);\n  color: var(--itanotificationpg-5-color);\n  text-transform: capitalize;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
